import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Error from "../../components/ui/Error";
import { useAddBookMutation } from "../../features/API/apiSlice";
import { filterSearch } from "../../features/Filter/filterSlice";
const initialValues = {
  name: "",
  author: "",
  thumbnail: "",
  price: "",
  rating: "",
  featured: false,
};
export default function AddBook() {
  const [addBook, { isLoading, isSuccess, isError }] = useAddBookMutation();
  const dispatch = useDispatch()

  const navigate = useNavigate();
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      dispatch(filterSearch(''))
      navigate("/");
    }
  }, [isSuccess, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setValues({
        ...values,
        [name]: checked,
      });
    } else {
      setValues({
        ...values,
        [name]: value,
      });
    }
  };

  function resetForm() {
    setValues(initialValues);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    addBook(values);
  };
  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
          <form onSubmit={handleSubmit} className="book-form">
            <div className="space-y-2">
              <label htmlFor="lws-bookName">Book Name</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-bookName"
                name="name"
                value={values.name}
                onChange={handleChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-author">Author</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-author"
                name="author"
                value={values.author}
                onChange={handleChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-thumbnail">Image Url</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-thumbnail"
                name="thumbnail"
                value={values.thumbnail}
                onChange={handleChange}
              />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label htmlFor="lws-price">Price</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-price"
                  name="price"
                  value={values.price}
                  onChange={handleChange}
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="lws-rating">Rating</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-rating"
                  name="rating"
                  min="1"
                  max="5"
                  values={values.rating}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                id="lws-featured"
                type="checkbox"
                name="featured"
                className="w-4 h-4"
                checked={values.featured}
                onChange={handleChange}
              />
              <label htmlFor="lws-featured" className="ml-2 text-sm">
                {" "}
                This is a featured book{" "}
              </label>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="submit"
              id="lws-submit"
            >
              Add Book
            </button>

            {isError && <Error message="There was an error adding Book!" />}
          </form>
        </div>
      </div>
    </main>
  );
}
